import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getFrequency = async () => {
  return await get<ApiResponse<any[]>>("/frequency").then((res) => res);
};

